// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box___4x2O"};